<template lang="pug">
  section
    WtTitle help
</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";

export default {
  name: "HelpCenter",

  components: { WtTitle }
};
</script>

<style lang="sass" scoped></style>
